import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WebDataApiService } from 'src/app/service/server/web-data-api-service';

export type RotateOption = 'ROTATE_90_CLOCKWISE' | 'ROTATE_90_COUNTERCLOCKWISE' | 'ROTATE_180' | null;

export interface ImageModifyModel {
        src: string;
        signedUrlSrc: string;
        reasonCode: string;
        comment: string;
        status: string;
        requestDetail: {
            [key: string]: any;
        };
}

export interface ImageModifyData {
    ok: boolean;
    imageModify: any;
}

@Component({
    selector: 'app-image-modify-dialog',
    templateUrl: './image-modify-dialog.component.html',
    styleUrls: ['./image-modify-dialog.component.scss']
})
export class ImageModifyDialogComponent {
    rotationForm: FormGroup;
    rotateOption: RotateOption = null;

    constructor(
        public dialogRef: MatDialogRef<ImageModifyDialogComponent, ImageModifyData>,
        @Inject(MAT_DIALOG_DATA) public data: ImageModifyModel,
        private fb: FormBuilder
    ){
        this.rotationForm = this.fb.group({
            rotation: [null, Validators.required]
        })
    }

    // step1 -> 2
    goNext(stepper: any): void{
        this.rotateOption = this.rotationForm.value.rotation;
        stepper.next();
    }

    onUpdate(): void{
        const modify = {
            src: this.data.src,
            reasonCode: this.data.reasonCode,
            comment: this.data.comment,
            status: this.data.status,
            requestDetail:{
                rotation: this.rotateOption,
            }
        };

        const result: ImageModifyData = {
            ok: true,
            imageModify: modify
        };

        this.dialogRef.close(result);
    }

    onCancel(): void{
        this.dialogRef.close({ ok: false, imageModify: []});
    }

    //step2
    getPreviewStyle(): any{
        let transform = 'none';

        if (this.rotateOption === 'ROTATE_90_CLOCKWISE') transform = 'rotate(90deg)';
        if (this.rotateOption === 'ROTATE_90_COUNTERCLOCKWISE') transform = 'rotate(-90deg)';
        if (this.rotateOption === 'ROTATE_180') transform = 'rotate(180deg)';

        return { transform: transform};
    }
}